import { CheckCircle, Shield, Layers, Smile } from "lucide-react";
import { COPY } from "@/content/copy";

const benefits = COPY.whyFlexaura.reasons.map((reason, index) => ({
  icon: [CheckCircle, Shield, Layers, Smile][index],
  title: reason.title,
  description: reason.description,
}));

const WhyFlexauraSection = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold mb-4 text-primary">
            {COPY.whyFlexaura.title}
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            The smart way to pay monthly for travel, education, and healthcare in UAE
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex gap-4 p-6 rounded-2xl card-shadow hover:elevated-shadow smooth-transition bg-card">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 gradient-bg rounded-lg flex items-center justify-center">
                  <benefit.icon className="w-6 h-6 text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold mb-2">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground font-body">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="text-xs text-muted-foreground font-body">
            Eligibility and limits are determined by our partners.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyFlexauraSection;